export default __webpack_public_path__ + "static/media/gl-12.9cdce19c.png";